import React from "react";
import { SITE } from "../lib/site";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-brand-dark text-brand-paper" data-testid="site-footer">
      <div className="container-page py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src={SITE.logo} alt="Edil Murgia" className="h-10 bg-white rounded-lg p-1.5" />
            <span className="heading-display text-2xl">Edil <span className="text-brand-terracotta">Murgia</span></span>
          </div>
          <p className="mt-5 text-brand-paper/70 leading-relaxed max-w-md">
            Impresa edile a Genova con oltre 40 anni di esperienza in costruzioni,
            ristrutturazioni e soluzioni chiavi in mano in tutta la Liguria.
          </p>
          <a href={SITE.whatsapp} target="_blank" rel="noreferrer" className="mt-6 inline-flex items-center gap-2 rounded-full bg-brand-terracotta hover:bg-brand-terracottaHover text-white px-5 py-2.5 text-sm font-semibold transition-colors" data-testid="footer-whatsapp">
            <Phone className="h-4 w-4" /> Scrivici su WhatsApp
          </a>
        </div>
        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.2em] text-brand-paper/50">Contatti</div>
          <ul className="mt-4 space-y-3 text-sm">
            {SITE.phones.map((p) => (
              <li key={p} className="flex items-center gap-2"><Phone className="h-4 w-4 text-brand-terracotta" /> {p}</li>
            ))}
            <li className="flex items-center gap-2 break-all"><Mail className="h-4 w-4 text-brand-terracotta" /> {SITE.email}</li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.2em] text-brand-paper/50">Sede</div>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 text-brand-terracotta shrink-0 mt-0.5" /> {SITE.address}</li>
            <li className="flex items-center gap-2"><Clock className="h-4 w-4 text-brand-terracotta" /> {SITE.hours}</li>
            <li className="text-brand-paper/50 mt-2">{SITE.vat}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-page py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-brand-paper/60">
          <div>© {new Date().getFullYear()} Edil Murgia · Tutti i diritti riservati</div>
          <div>Sito reimmaginato con AI · Privacy & Cookie Policy</div>
        </div>
      </div>
    </footer>
  );
}
